import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import Toggle from 'react-toggle'
import { useDispatch } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { useTranslation } from 'react-i18next'

import { deleteDatabaseDevice, deleteDeviceCustomer } from '../../../../../shared/api/action/DeviceActions'
import { getCompanyById } from '../../../../../shared/api/action/CompaniesActions'
import CustomButton from '../../CustomButton'

const VehicleDeleteModal = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.editAssetContainer.vehicleDeleteModal' });
	const { onHide, device, userRole } = props;

	const [databaseDelete, setDatabaseDelete] = useState(false);
	const [company, setCompany] = useState(null);
	const [showDeleteModal, setShowDeleteModal] = useState();

	useEffect(() => {
		if (userRole === 'system_admin') {
			getCompany()
		}
	}, [])

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	const getCompany = () => {
		toggleLoader(true);
		getCompanyById(userRole, device.company_id)
			.then((res, err) => {
				toggleLoader(false);
				const { company } = res.data.response
				setCompany(company)
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getCompany error: ', error.response, error)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const handleDeleteClick = () => {
		const params = {
			device_id: device.device_id,
			user_role: userRole
		};

		let funcName = null
		if (databaseDelete) {
			funcName = deleteDatabaseDevice(params)
		} else {
			funcName = deleteDeviceCustomer(params)
		}

		toggleLoader(true);
		funcName
			.then((res) => {
				toggleLoader(false);
				navigate('/managevehicles');
				toastr.success(t('vehicleDeleted'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log(error);

				setShowDeleteModal(false)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	console.log('PROPS VehicleDeleteModal: ', props)

	return (
		<Modal
			show
			onHide={onHide}
			dialogClassName="has-error"
			backdropClassName="custom-modal-backdrop"
			className="modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title className="delete-title">{t('titleDeleteVehicle')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text">
					{`${t('modalText')} ${device.vehicle_name || device.device_id} ?`}
				</div>
			</Modal.Body>
			<Modal.Footer className="default-modal-footer modal-footer">
				{userRole === 'system_admin' && company && !company.asset_deletion_protection
					&& (
						<label>
							<span className="toggle-left-title">{t('titleDeleteDB')}</span>
							<Toggle
								name="databaseDelete"
								checked={databaseDelete}
								onChange={e => setDatabaseDelete(e.target.checked)}
							/>
						</label>
					)}
				<CustomButton variant="delete" onClick={handleDeleteClick}>{t('btnDelete')}</CustomButton>
			</Modal.Footer>
		</Modal>
	)
}

VehicleDeleteModal.propTypes = {
	device: PropTypes.objectOf(PropTypes.any).isRequired,
	userRole: PropTypes.string.isRequired,
	onHide: PropTypes.func.isRequired
}

export default VehicleDeleteModal;
